module.exports = __webpack_public_path__ + "static/media/photo2.a6134dd3.jpg";